import React from 'react';
import PropTypes from 'prop-types';
import { getUrl, getDescText, getPageYear } from '../../common/services/builders';

//function GenericWebpageListerSearchItem({ entry, settings }) {
function GenericWebpageListerSearchItem({ entry }) {

    var dateLabel = "Published ";

    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    
                    <span className="category--tag">{renderTypeTag(entry)}</span>
                </div>
                <div className="small-6 column text-right">
                    <span className="category--tag">{renderMemberTag(entry)}</span>
                </div>
            </div>
            <div className="row column">
                <h4><a href={getUrl(entry)}>{entry.title}</a></h4>
                <span dangerouslySetInnerHTML={{__html: getDescText(entry)}}></span>
                <span className="date">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-clock"></use>
                    </svg>
                    {dateLabel}{getPageYear(entry)}
                </span>


            </div>
        </div>
    );
    
}

GenericWebpageListerSearchItem.propTypes = {
    entry: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

function renderMemberTag(entry) {
    if (entry.sys.contentTypeId == 'weldasearch'){
        return <span className="category--tag">Industrial members</span>;
    }
    if(entry.sys.metadata.permission){
        switch (entry.sys.metadata.permission) {
            case 'OPEN':
                return <span className="category--tag">All members</span>;
            case 'IM':
                return <span className="category--tag">Industrial members</span>;
            case 'PRO':
                return <span className="category--tag">Professional members</span>;	
            default:
                return <span className="category--tag">Public</span>;
        }
    }
    else{
        return <span className="category--tag">Public</span>;
    }

}


function renderTypeTag(entry){
    if(entry.sys.dataFormat == 'webpage'){
        var sectionType = "WebPage";
        var sysUri = entry.sys.uri.toLowerCase();
        var contentTypes = [
            { path:"/what-we-do",sectionType:"What We Do"},
            { path:"/who-we-are",sectionType:"Who We Are"},
            { path:"/best-practice-guides/",sectionType:"Best Practice Guides"},
            { path:"/faqs/",sectionType:"FAQs"},
            { path:"/job-knowledge/",sectionType:"Job Knowledge"},
            { path:"/knowledge-summaries",sectionType:"Knowledge Summaries"},
            { path:"/published-papers/",sectionType:"Published Papers"},
            { path:"/software-toolkits/",sectionType:"Software Toolkits"},
            { path:"/technical-articles/",sectionType:"Technical Articles"},
            { path:"/welding-abstracts-journal",sectionType:"Welding Abstracts Journals"},
            { path:"/twi-core-research/",sectionType:"Core Research"},
            { path:"/joint-industry-projects",sectionType:"Joint Industry Projects"},
            { path:"/public-funded-projects",sectionType:"Public Funded Projects"},
            { path:"/industrial-member-reports",sectionType:"Industrial Member Reports"},
            { path:"/technical-literature-reviews",sectionType:"Technical Literature Reviews"},
            { path:"media-and-events/press-releases",sectionType:"Press Releases"},
            { path:"media-and-events/insights",sectionType:"Insights"},
            { path:"media-and-events/connect",sectionType:"Connect"},
            { path:"media-and-events/bulletin",sectionType:"Bulletin"},
            { path:"media-and-events/industry-updates",sectionType:"Industry Updates"},
        ];

        contentTypes.forEach(function(element){
            if (sysUri.includes(element.path))
            {
                sectionType = element.sectionType;
            }                
        });

        return <span className="category--tag">{sectionType}</span>;
    }
    else{
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>;
    }
}

// function getDateLabel(entry) {
//     if(entry.sys.dataFormat == 'webpage'){
//         var sectionType = "WebPage";
//         var sysUri = entry.sys.uri.toLowerCase();
//         var contentTypes = [
//             { path:"/technical-literature-reviews",sectionType:"Technical Literature Reviews", dateLabel: "Published"},

//         ];

//         contentTypes.forEach(function(element){
//             if (sysUri.includes(element.path))
//             {
//                 sectionType = element.sectionType;
//             }                
//         });

//         return <span className="category--tag">{sectionType}</span>;
//     }
//     else{
//         return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>;
//     }

// }

export default GenericWebpageListerSearchItem;